var transition = {
  opacity: 'opacity 0.3s ease-out',
  outline: 'outline 0.3s ease-out',
  border: 'border 0.3s ease-out',
  color: 'color 0.3s ease-out',
  backgroundColor: 'background-color 0.3s ease-out',
  boxShadow: 'box-shadow 0.3s ease-out',
  transform: 'transform 0.3s ease-out'
};
export default transition;